export default interface IServiceServer {
    start(): void;
}
